import templateUrl from "./app.html";

export const appComponent = {
  templateUrl,

  controller: class AppController {
    constructor(HomeService) {
      "ngInject";
      this.homeService = HomeService;
    }

    $onInit() {
      this.homeService.getFeatures().then((features) => {
        this.homeOptions = angular.copy(features);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/app.component.js